import React, { useState } from 'react';
import moment from 'moment';
import '../myAccount.scss';
import InterestPaidTo from '../InterestPaidTo';
import AccountClosure from '../AccountClosure/AccountClosure';
import NoticeAccountClosure from '../AccountClosure/NoticeAccountClosure';
import TextInput from '../../Form/TextInput/TextInput';
import Section from '../Section';

/** @import {NsAccountInfoProps} from './NsAccountInfoTypes' */

function NsAccountInfo(/** @type {NsAccountInfoProps} */ props) {
    const profileData = props.profileData;
    const [requestSubmitted, setRequestSubmitted] = useState(false);

    const renderRequestPending = () => {
        return (
            <>
                <div className="my-account__content my-account__content--medium-margin-bottom">
                    <h1 className="my-account__secondary-title">Closure request has been submitted</h1>
                </div>
            </>
        );
    }

    const onActionComplete = () => {
        setRequestSubmitted(true);
    };

    if (requestSubmitted)
        return renderRequestPending();

    const tooltipContent = () => {
        let m = moment('2022-01-01');
        //@ts-expect-error need to understand how to use moment.js
        m.add(profileData.noticePeriod, profileData.noticePeriodUnit);

        let en = moment();
        //@ts-expect-error need to understand how to use moment.js
        en.add(profileData.noticePeriod, profileData.noticePeriodUnit);
        
        return `This means that you’ll need to let us know ${profileData.noticePeriod} days in advance if you’d like to make a withdrawal.<br /><br />` +
            `On the morning of the ${m.format('DDDo')} day, we’ll transfer the money to your linked account.<br /><br />` +
            `For example: if you gave us notice today, you’d have your money on ${en.format('D MMMM')}.`;
    }
     
    return (
        <>
            <div className="my-account__content my-account__content--small-margin-bottom my-account__content--max-width">
                <div className="my-account__row">
                    <div className="my-account__col my-account__col--full-width">
                        <Section title="Notice Period" hideEditing={true} showTooltip={true} tooltipContent={tooltipContent()}>
                            <TextInput className="my-account__input" value={profileData.noticePeriod + ' ' + profileData.noticePeriodUnit} disabled />
                        </Section>
                    </div>
                    <div className="my-account__col my-account__doubleCol my-account__col--full-width my-account__col--small-margin-left">
                        <InterestPaidTo profile={profileData} />
                    </div>
                </div>
            </div>
            <div className="my-account__content my-account__content--small-margin-bottom">
                <div className="my-account__left">
                    {profileData.balance > 0 && <NoticeAccountClosure
                        productName={profileData.productName}
                        mobileNumber={profileData.mobileNumber}
                        accountId={profileData.accountId}
                        accountStatus={profileData.accountStatus}
                        destinationAccounts={profileData.destinationAccounts}
                        onActionComplete={onActionComplete}
                    />}

                    {profileData.balance === 0 && <AccountClosure
                        productName={profileData.productName}
                        mobileNumber={profileData.mobileNumber}
                        accountId={profileData.accountId}
                        accountStatus={profileData.accountStatus}
                        onActionComplete={onActionComplete}
                    />}
                </div>
            </div>
        </>
    )
};

export default NsAccountInfo;